import React from 'react';
import SingleForm from 'components/SingleForm';
import { getClasificacionAdministrativa } from 'api/catalogos/indexSAC';

export const permissionClasificacionAdministrativa = {
  permissionModel: 'clasificacionadministrativa',
};

// eslint-disable-next-line react/prop-types
function ClasificacionAdministrativa({ permission }) {
  return (
    <SingleForm
      title="Clasificación Administrativa"
      get={getClasificacionAdministrativa}
      readOnly
      withoutState
      permission={permission}
      needsKey // muestra la clave
      needsConcepto // muestra el campo "concepto"
      needsDescription={false} // desactiva la columna "Descripción"
    />
  );
}

export default ClasificacionAdministrativa;
